import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IAppState, DashActionCreators, IMentorCompletionsListResponse, IDonorConnectCompletionsReportResponse } from '@nkr/store/index';
import { IDonorConnectCompletionsReport, IMentorCompletionsList } from '@nkr/models/index';
import { Button, ControlLabel, FormControl, FormGroup, Well } from 'react-bootstrap';
import { downloadFile } from '@nkr/services/download-file';
import Details from './details';
import Grid from './grid';

interface IProps { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getReport: (year: number, month: number, csv: boolean) => Promise<IDonorConnectCompletionsReportResponse>,
    getReportExport: (year: number, month: number, csv: boolean) => Promise<IDonorConnectCompletionsReportResponse>,
    getMentorCompletionDetails: (year: number, month: number, userId: number) => Promise<IMentorCompletionsListResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    year: number,
    month: number,
    list: IDonorConnectCompletionsReport[],
    details: {
        show: boolean,
        data: IMentorCompletionsList,
        userName: string
    }
}

class DonorConnectCompletions extends Component<TProps, IState> {
    readonly state: IState = {
        year: moment().add(-1, 'months').year(),
        month: moment().add(-1, 'months').month() + 1,
        list: [],
        details: {
            show: false,
            data: null,
            userName: ''
        }
    }

    componentDidMount = () => {
        let parsed = qs.parse(window.location.search);

        let month = parsed.m != null ? parseInt(parsed.m) : moment().add(-1, 'months').month() + 1;
        let year = parsed.y != null ? parseInt(parsed.y) : moment().add(-1, 'months').year();

        this.setState({
            month,
            year
        }, () => {
            this.getData();
        });
    }

    getData = () => {
        this.props.showLoading('Getting Donor Mentor users, one moment please...').then(() => {
            this.props.getReport(this.state.year, this.state.month, false).then(response => {
                if (response.data.success) {
                    this.setState({
                        list: response.data.results
                    });
                }
                this.props.hideLoading();
            });
        });
    }

    setUrlParameters = () => {
        let paramList = [];

        paramList.push(encodeURI('m=' + this.state.month));
        paramList.push(encodeURI('y=' + this.state.year));

        let params = paramList.join('&');

        let newUrl = '/donor-connect/report/completions?' + params

        window.history.pushState({}, '', newUrl);
    };

    handleDonorConnectMentorDetails = (userId: number) => {
        let { year, month } = this.state;

        let data = this.state.list.find(x => x.userId == userId);

        this.props.showLoading('Getting Mentor Details, one moment please...').then(() => {
            this.props.getMentorCompletionDetails(year, month, userId).then(response => {
                if (response.data.success) {
                    this.setState({
                        details: {
                            show: true,
                            data: response.data.results,
                            userName: data.username
                        },
                    });
                }
                this.props.hideLoading();
            });
        });
    }

    handleCancel = () => {
        this.setState({
            details: {
                show: false,
                data: null,
                userName: ''
            },
        });
    }

    handleYearChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            year: parseInt(e.currentTarget.value)
        });
    }

    handleMonthChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            month: parseInt(e.currentTarget.value)
        });
    }

    handleUpdate = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.setUrlParameters();
        this.getData();
    }

    handleExport = () => {
        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getReportExport(this.state.year, this.state.month, true).then((response: any) => {

                downloadFile(response.data, `mentor-completions-export`, 'text/csv');

                this.props.hideLoading();
            });
        });
    }

    render = () => {
        const months = _.range(1, 13);
        const years = _.range(2021, moment().year() + 1);

        return (
            <>
                <div className='container'>
                    <h1 >Mentor Completions</h1>

                    <Well bsSize='sm' style={{ marginBottom: 5 }}>
                        <form className='form-inline' onSubmit={this.handleUpdate}>
                            <FormGroup style={{ marginRight: 10 }}>
                                <ControlLabel>Year:</ControlLabel> &nbsp;
                                <FormControl
                                    componentClass='select'
                                    value={this.state.year}
                                    onChange={this.handleYearChange}>
                                    {years.map((year, index) =>
                                        <option key={'yr-' + index} value={year}>{year}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup style={{ marginRight: 10 }}>
                                <ControlLabel>Month:</ControlLabel> &nbsp;
                                <FormControl
                                    componentClass='select'
                                    value={this.state.month}
                                    onChange={this.handleMonthChange}>
                                    {months.map((month, index) =>
                                        <option key={'mo-' + index} value={month}>{month}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <Button bsStyle='primary' type='submit'>Update</Button>
                            </FormGroup>

                            <FormGroup className='pull-right'>
                                <Button bsStyle='primary' onClick={() => this.handleExport()}>Export CSV</Button>
                            </FormGroup>
                        </form>
                    </Well>

                    <Grid
                        data={this.state.list}
                        onGetDetails={this.handleDonorConnectMentorDetails} />
                </div>

                <Details
                    show={this.state.details.show}
                    data={this.state.details.data}
                    userName={this.state.details.userName}
                    onClose={this.handleCancel} />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getReport: (year, month) => {
            return dispatch(DashActionCreators.getDonorConnectCompletions(year, month, false));
        },
        getReportExport: (year, month) => {
            return dispatch(DashActionCreators.getDonorConnectCompletions(year, month, true));
        },
        getMentorCompletionDetails: (year, month, username) => {
            return dispatch(DashActionCreators.getMentorCompletionDetails(year, month, username));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorConnectCompletions);